import React, { useCallback, useState } from 'react';
import { safeHTML } from '../../../../utils/safeHTML';

import Puzzle from '../../../scenes/puzzle/Puzzle';
import { puzzleContent } from '../../../../constants/copyright';
import { useTranslation } from '../../../../translations';

const QuizItemPuzzle = React.forwardRef(function QuizItemPuzzle(
  { image, answers, index, text: title, note, setScore, nextStep },
  ref,
) {
  const { text } = puzzleContent;
  const [isDone, setIsDone] = useState(false);
  const { t } = useTranslation();

  const onAnimationEnd = useCallback(() => {
    setScore(answers[0]?.id);
    nextStep();
    setIsDone(false);
  }, [answers]);

  const onComplete = useCallback(() => setIsDone(true), []);

  return (
    <div className={'quiz__item quiz__item_puzzle'} ref={ref}>
      <div className={'quiz__item-block'}>
        <h2 className='quiz__item-title'>{safeHTML(t(title))}</h2>
        <p className='quiz__item-text'>{safeHTML(t(text))}</p>
        <Puzzle index={index} image={image} onComplete={onComplete} isDone={isDone} onAnimationEnd={onAnimationEnd} />
        <p className={'quiz__item-text quiz__item-text_note'}>{safeHTML(note)}</p>
      </div>
    </div>
  );
});

export default QuizItemPuzzle;
QuizItemPuzzle.propTypes = {};
